import React from 'react';
import { Box } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';
import { useRFHInput } from 'hooks';
import { LRRangeDropdown } from 'components/LRRangeDropdown';
import { PRICE_RANGE } from '../../constants';

export function PriceSection({ onChange }) {
    const formMethods = useFormContext();

    const { value: priceMin, handleChange: setPriceMin } = useRFHInput('preferences.price_min', formMethods);
    const { value: priceMax, handleChange: setPriceMax } = useRFHInput('preferences.price_max', formMethods);

    return (
        <Box maxWidth={[1, 350]}>
            <LRRangeDropdown
                minValue={priceMin}
                maxValue={priceMax}
                options={PRICE_RANGE}
                onMinValueChange={(option)=> {
                    setPriceMin(option);
                    onChange(false);
                }}
                onMaxValueChange={(option)=> {
                    setPriceMax(option);
                    onChange(false);
                }}
                compareAsNumbers={true}
            ></LRRangeDropdown>
        </Box>
    );
}
